import footerLogo from '../images/logo-footer.svg'
function Footer(){
    return (
        <footer className="footer bg-cyan">
            <div className="footer--container">   
            <div className="footer--logo"><img src={footerLogo} alt="logo" /></div>
   <div className="footer--links txt-cyan-dark">
    <a href="#" className="footer--link">About</a>
    <a href="#" className="footer--link">Services</a>
    <a href="#" className="footer--link">Projects</a>
   </div>
   <div className="footer--socials txt-cyan-dark">
    <a href="#" className="footer--social"><i class="fa-brands fa-facebook-f"></i></a>
    <a href="#" className="footer--social"><i class="fa-brands fa-twitter"></i></a>
    <a href="#" className="footer--social"><i class="fa-brands fa-pinterest"></i></a>
    <a href="#" className="footer--social"><i class="fa-brands fa-youtube"></i></a>
    <a href="#" className="footer--social"><i class="fa-brands fa-instagram"></i></a>
   </div>
   </div>

        </footer>
    )
}
export default Footer;